export const DrinkCategories = [
  {
    name: "Piće",
    items: [
      {
        name: "Negazirana voda",
        price: 2,
      },
      {
        name: "Kisjela voda",
        price: 2,
      },
      {
        name: "Negazirani sokovi",
        price: 3,
      },
      {
        name: "Gazirani sokovi",
        price: 3,
      },
      {
        name: "Red Bull",
        price: 4,
      },
    ],
  },
  {
    name: "Topli napici",
    items: [
      {
        name: "Espresso",
        price: 2,
      },
      {
        name: "Capuccino",
        price: 2.5,
      },
      {
        name: "Nes kafa",
        price: 3,
      },
      {
        name: "Topla čokolada",
        price: 3,
      },
      {
        name: "Čaj",
        price: 3,
      },
      {
        name: "Matcha",
        price: 4,
      },
      {
        name: "Matcha latte",
        price: 4.5,
      },
    ],
  },
  {
    name: "Prirodni sokovi",
    items: [
      {
        name: "Kruška i jabuka",
        price: 4,
      },
      {
        name: "Limunada",
        price: 3,
      },
      {
        name: "Američka limunada",
        price: 3.5,
      },
      {
        name: "Pomorandža",
        price: 4,
      },
      {
        name: "Prirodni mix",
        price: 4.5,
      },
    ],
  },
  {
    name: "Smoothies",
    items: [
      {
        name: "Crveni",
        price: 6,
      },
      {
        name: "Zeleni",
        price: 6,
      },
      {
        name: "Žuti",
        price: 6,
      },
      {
        name: "Ljubičasti",
        price: 6,
      },
    ],
  },
  {
    name: "Alkoholna pića",
    items: [
      {
        name: "Bijelo vino",
        price: 6,
      },
      {
        name: "Crno vino",
        price: 6,
      },
      {
        name: "Prosecco",
        price: 7,
      },
      {
        name: "Somersby",
        price: 3.5,
      },
      {
        name: "Pivo",
        price: 4,
      },
    ],
  },
];
